import { buildAgentUiSchemas } from "src/agentNode/hooks/useAgentSchemas";
import { ResourceSample } from "src/api/connectApi/types";
import { AgentVersion } from "src/clients/agent-management";
import { generateSampleReportForSchema } from "src/datasets/utils";

export const getSampleReportsForAgentNode = (
  agentVersion: AgentVersion | undefined,
): ResourceSample[] => {
  const defaultSample = { response: "I'm a helpful agent" };

  if (!agentVersion?.configuration?.output_schema) {
    return [{ name: "Agent Node response", sample: defaultSample }];
  }

  const schemas = buildAgentUiSchemas(agentVersion.configuration);
  const outputSchema = schemas.output;

  if (!outputSchema || outputSchema.properties.length === 0) {
    return [{ name: "Agent Node response", sample: defaultSample }];
  }
  const sampleReport = generateSampleReportForSchema({
    schema: outputSchema,
  });

  return [{ name: "Agent Node response", sample: { response: sampleReport } }];
};
